import { Box } from '@atlaskit/primitives';

export const UserOnboardingPage = () => {
	// eslint-disable-next-line @dev-agents/rules/i18n/text-wrapped-in-format-message
	return <Box>User Onboarding</Box>;
};
